import { useEffect } from 'react';

export const useScript = (url: string, callback?: () => void, noModule?: boolean) => {
  useEffect(() => {
    if (!document.querySelector(`script[src="${url}"`)) {
      const script = document.createElement('script');
      script.src = url;
      if (noModule) {
        script.noModule = true;
      } else if (noModule === false) {
        script.type = 'module';
      }
      document.body.appendChild(script);

      script.onload = () => {
        if (callback) {
          callback();
        }
      };
    }
  });
};
